export default "__VITE_ASSET__C4G__nN4__"